<template>
  <div class="list">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        库存列表
        <div @click="getting()" class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px">刷新</div>
        </div>
      </div>
    </div>
    <div v-if="role" class="body">
      <div class="form-title">
        <div style="padding-left:10px">筛选查询</div>
        <el-button
          @click="showAdd = true,getSupplier('')"
          plain
          class="addSupplier"
          style="margin-right:20px"
        >新建库存</el-button>
      </div>
      <div style="background-color:white" class="search-box">
        <el-row class="search" :gutter="10">
          <el-col :span="2">
            <div class="label">商品名称:</div>
          </el-col>
          <el-col :span="4">
            <el-input v-model="name" clearable size="small" placeholder="商品名称"></el-input>
          </el-col>
          <el-col :span="2">
            <div class="label">商品货号:</div>
          </el-col>
          <el-col :span="4">
            <el-input v-model="item_no" clearable size="small" placeholder="商品货号"></el-input>
          </el-col>
          <el-col :span="4" align="center">
            <div class="search_button" @click="getting()">搜索</div>
          </el-col>
        </el-row>
      </div>
      <div style="background-color:white;margin-top:19px;">
        <div class="table-top-border">
          <div class="table-top-title">
            <div class="table-top-left">
              <div>
                <i class="fas fa-bars"></i>
              </div>
              <div>数据列表</div>
            </div>
          </div>
        </div>
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column prop="id" label="编号" width="50"></el-table-column>
          <el-table-column label="商品名称">
            <template slot-scope="scope">
              <router-link :to="'/admin/inventoryLog/'+scope.row.id">
                <el-link type="primary">{{scope.row.name}}</el-link>
              </router-link>
            </template>
          </el-table-column>
          <el-table-column prop="item_no" label="商品货号"></el-table-column>
          <el-table-column prop="unit" label="储存单位"></el-table-column>
          <el-table-column prop="brand" label="品牌"></el-table-column>
          <el-table-column prop="specification" label="规格" width="100px"></el-table-column>
          <el-table-column prop="sell_price" label="售价"></el-table-column>
          <el-table-column prop="number" label="剩余数量"></el-table-column>
          <el-table-column label="操作" align="center" width="150px">
            <template slot-scope="scope">
              <el-link type="primary" @click="showEnter = true,enterId = scope.row.id">入库</el-link>
              <el-link
                style="margin-left:20px"
                type="primary"
                @click="showExit = true,exitId = scope.row.id"
              >出库</el-link>
              <el-link
                style="margin-left:20px"
                type="primary"
                @click="deleteInventory(scope.row.id)"
              >删除</el-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="pager">
          <el-row>
            <el-col :span="100">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                :page-size="15"
                @current-change="setPage"
              >1</el-pagination>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <noAccess v-else></noAccess>
    <!-- 入库操作 -->
    <el-dialog title="入库操作" :visible.sync="showEnter" width="30%">
      <el-form :model="form">
        <el-form-item label="商品数量" :label-width="formLabelWidth">
          <el-input v-model="form.number" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="商品价格" :label-width="formLabelWidth">
          <el-input v-model="form.price" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="供应商" :label-width="formLabelWidth">
          <el-autocomplete
            style="width:100%"
            v-model="form.from"
            :fetch-suggestions="querySearchAsync"
            @select="supplierSelect"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="备注" :label-width="formLabelWidth">
          <el-input
            v-model="form.remark"
            autocomplete="off"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4}"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showEnter = false">取 消</el-button>
        <el-button type="primary" @click="enter_inventory()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 出库操作 -->
    <el-dialog title="出库操作" :visible.sync="showExit" width="30%">
      <el-form :model="formExit">
        <el-form-item label="商品数量" :label-width="formLabelWidth">
          <el-input v-model="formExit.number" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="客户名称" :label-width="formLabelWidth">
          <el-input v-model="formExit.to" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="出库时间" :label-width="formLabelWidth">
          <el-input placeholder="默认为当前时间" v-model="formExit.send_time" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="送货人" :label-width="formLabelWidth">
          <el-input v-model="formExit.send_member" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="发票号" :label-width="formLabelWidth">
          <el-input v-model="formExit.duty_code" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注" :label-width="formLabelWidth">
          <el-input
            v-model="formExit.remark"
            autocomplete="off"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4}"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showExit = false">取 消</el-button>
        <el-button type="primary" @click="exit_inventory()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 新建库存 -->
    <el-dialog title="新建库存" :visible.sync="showAdd" width="30%">
      <el-form :model="formAdd">
        <el-form-item label="商品名称" :label-width="formLabelWidth">
          <el-input v-model="formAdd.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="商品货号" :label-width="formLabelWidth">
          <el-input v-model="formAdd.item_no" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="供应商名称" :label-width="formLabelWidth">
          <el-autocomplete
            style="width:100%"
            v-model="formAdd.from"
            :fetch-suggestions="querySearchAsync"
            @select="supplierSelect"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="数量" :label-width="formLabelWidth">
          <el-input v-model="formAdd.number" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="品牌" :label-width="formLabelWidth">
          <el-input v-model="formAdd.brand" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="规格" :label-width="formLabelWidth">
          <el-input v-model="formAdd.specification" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="价格" :label-width="formLabelWidth">
          <el-input v-model="formAdd.price" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注" :label-width="formLabelWidth">
          <el-input
            v-model="formAdd.remark"
            autocomplete="off"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4}"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAdd = false">取 消</el-button>
        <el-button type="primary" @click="add_inventory()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'inventoryList',
  data() {
    return { serve: this.$store.state.serve,
      role:true,
      username: this.$cookies.get('username'),
      token: this.$cookies.get('token'),
      serve: this.$store.state.serve,
      name: null,
      item_no: null,
      supplier: null,
      tableData: [],
      form: {},
      showEnter: false,
      formLabelWidth: '100px',
      enterId: '',
      exitId: '',
      formExit: {},
      showExit: false,
      showAdd: false,
      formAdd: {},
      restaurants: [],
      total: 0,
      timeout: null
    }
  },
  created() {
    this.$store.state.topActiveId = 8
    this.$store.state.leftTitle = '库存管理'
    this.getting()
    this.getSupplier('')
  },
  methods: {
    alert_success(message) {
      this.$message({
        type: 'success',
        message: message,
        offset: 200
      })
    },
    alert_error(message) {
      this.$message({
        type: 'error',
        message: message,
        offset: 200
      })
    },
    deleteInventory(id) {
      var where = {
        username: this.username,
        token: this.token,
        id: id
      }
      this.$confirm(
        '此操作将永久删除该库存和此库存的记录, 是否继续?',
        '删除提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error'
        }
      )
        .then(() => {
          this.axios
            .get(this.serve + '/admin/delete_inventory', {
              params: where
            })
            .then(res => {
              var data = res.data
              if (data.status == 'success') {
                this.alert_success('删除成功!')
                this.getting()
              }else if(data.code == '403'){
                this.$message.error(data.msg);
              }else {
                this.alert_error('删除失败!')
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
            offset: 200
          })
        })
    },
    getSupplier(name) {
      this.axios
        .get(this.serve + '/admin/get_supplier_list', {
          params: {
            name: name,
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          var data = res.data
          if (data.status == 'success') {
            var row = []
            var data1 = data.data
            for (var i in data1) {
              var a = {}
              a.value = data1[i]
              row[i] = a
            }
            this.restaurants = row
          } else {
            if(data.msg == "无权访问"){
              this.role = false
            }
            this.restaurants = []
          }
        })
    },
    querySearchAsync(queryString, cb) {
      var restaurants = this.restaurants
      var results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        cb(results)
      }, 3000 * Math.random())
    },
    createStateFilter(queryString) {
      return state => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        )
      }
    },
    supplierSelect(item) {
      console.log(item)
    },
    setPage(v) {
      //分页

      this.page = v
      this.getting(v)
    },
    getting(page) {
      const loading = this.$loading({
        lock: true,
        text: '正在加载...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.axios
        .get(this.serve + '/admin/list_inventory', {
          params: {
            username: this.username,
            token: this.token,
            name: this.name,
            item_no: this.item_no,
            supplier: this.supplier,
            page: page ? page : null
          }
        })
        .then(res => {
          var data = res.data
          if (data.status == 'success') {
            this.tableData = data.data.results
            this.total = data.data.total
          } else {
            this.tableData = []
          }
          loading.close()
        })
    },
    add_inventory() {
      var form = this.formAdd
      if (form.number > 0 || form.price > 0) {
      } else {
        this.$message({
          showClose: true,
          message: '价格和数量必须大于0!',
          type: 'error',
          offset: 200
        })
        return
      }
      this.showAdd = !this.showAdd
      form.username = this.username
      form.token = this.token
      this.axios
        .get(this.serve + '/admin/enter_inventory', {
          params: form
        })
        .then(res => {
          var data = res.data;
         
          if (data.status == 'success') {
            this.$message({
              showClose: true,
              message: '入库成功!',
              type: 'success',
              offset: 200
            })
          }else if(data.code == '403'){
             this.$message.error(data.msg);
          } else {
            this.$message({
              showClose: true,
              message: '入库失败!',
              type: 'error',
              offset: 200
            })
          }
          this.formAdd = {}
          this.getting()
        })
    },
    exit_inventory() {
      var form = this.formExit
      if (form.number > 0) {
      } else {
        this.$message({
          showClose: true,
          message: '数量必须大于0!',
          type: 'error',
          offset: 200
        })
        return
      }
      if (form.to == '') {
        this.$message({
          showClose: true,
          message: '客户名称不能为空!',
          type: 'error',
          offset: 200
        })
        return
      }
      this.showExit = !this.showExit
      form.fid = this.exitId
      form.username = this.username
      form.token = this.token
      this.axios
        .get(this.serve + '/admin/exit_inventory', {
          params: form
        })
        .then(res => {
          var data = res.data
          if (data.status == 'success') {
            this.$message({
              showClose: true,
              message: '出库成功!',
              type: 'success',
              offset: 200
            })
          }else if(data.code == '403'){
             this.$message.error(data.msg);
          }  else {
            this.$message({
              showClose: true,
              message: '出库失败!',
              type: 'error',
              offset: 200
            })
          }
          this.getting()
          this.formExit = {}
        })
    },
    enter_inventory() {
      var form = this.form
      if (form.number > 0 || form.price > 0) {
      } else {
        this.$message({
          showClose: true,
          message: '价格和数量必须大于0!',
          type: 'error',
          offset: 200
        })
        return
      }
      this.showEnter = !this.showEnter
      form.username = this.username
      form.token = this.token
      form.fid = this.enterId
      this.axios
        .get(this.serve + '/admin/enter_inventory', {
          params: form
        })
        .then(res => {
          var data = res.data
          if (data.status == 'success') {
            this.$message({
              showClose: true,
              message: '入库成功!',
              type: 'success',
              offset: 200
            })
          }else if(data.code == '403'){
             this.$message.error(data.msg);
          }  else {
            this.$message({
              showClose: true,
              message: '入库失败!',
              type: 'error',
              offset: 200
            })
          }
          this.form = {}
          this.getting()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  .search-box {
    width: 1054px;
    height: 86px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
  }
  background: #f5f5f5;
  color: #333;
  min-height: 1000px;
  padding-bottom: 100px;
  .pager {
    display: flex;
    justify-content: center;
  }
  .addSupplier {
    margin-right: 20px;
  }
  .addSupplier:hover {
    color: white;
    background-color: #0099ff;
  }
  .topBar {
    margin-bottom: 40px;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .form-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .body {
    width: 1056px;
    margin: 0 auto;
    .table-top-title {
      background-color: #eee;
      width: 100%;
      height: 46px;
      display: flex;
      justify-content: space-between;
    }
    .table-top-left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .table-top-border {
      border: 1px solid rgba(221, 221, 221, 1);
    }
    .search {
      display: flex;
      justify-content: left;
      .el-col {
        line-height: 80px;
      }
    }
    .search .el-col {
      line-height: 80px;
    }
    .search_button {
      text-align: center;
      line-height: 28px;
      font-size: 14px;
      font-family: 'MicrosoftYaHeiLight';
      font-weight: 300;
      color: rgba(102, 102, 102, 1);
      width: 74px;
      height: 28px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      position: absolute;
      right: 18px;
      top: 29px;
      cursor: pointer;
    }
    .search_button:hover {
      background-color: #0099ff;
      color: #fff;
    }
    .label {
      text-align: right;
      padding-right: 10px;
      font-size: 14px;
    }
  }
}
</style>